import script from "./CustomVideoPlayer.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomVideoPlayer.vue?vue&type=script&setup=true&lang=js"

import "./CustomVideoPlayer.vue?vue&type=style&index=0&id=1582c63d&scoped=true&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1582c63d"]])

export default __exports__